<template>
  <div>
    <v-img :src="require('../assets/hd2.jpg')"></v-img>

    <v-container>
      <v-window v-model="step" :continuous="false">
        <v-window-item :value="1">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>

              <v-col cols="12" class="mt-10 px-5">
                患者姓名 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <input type="text" v-model="info.name" ref="name" placeholder="请在此处填写姓名" :disabled="disabled">
              </v-col>

              <v-col cols="12" class="mt-8 px-5">
                患者性别 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-btn class="px-10 ml-3" @click="setSex('male')" ref="male">
                  <v-icon left>mdi-gender-male</v-icon>
                  男
                </v-btn>
                <v-btn class="px-10 ml-3" @click="setSex('female')" ref="female">
                  <v-icon left>mdi-gender-female</v-icon>
                  女
                </v-btn>
              </v-col>

              <v-col cols="12" class="mt-8 px-5">
                出生年月 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="info.birthday"
                        persistent
                        width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <input type="text" v-model="info.birthday" v-on="on" readonly ref="birthday">
                  </template>
                  <v-date-picker v-model="info.birthday" type="month" locale="zh-cn" color="#0080aa" :disabled="disabled">
                    <v-spacer></v-spacer>
                    <v-btn text color="#0080aa" @click="modal = false">取消</v-btn>
                    <v-btn text color="#0080aa" @click="$refs.dialog.save(info.birthday)">确定</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>


        <v-window-item :value="2">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-10 px-5">
                患者身份证号码 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <input type="text" v-model="info.id_no" ref="id_no" placeholder="请在此处填写身份证号码" :disabled="disabled">
              </v-col>

              <v-col cols="12" class="mt-8 px-5">
                上传患者身份证正、反面照片或户口本页 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-file-input accept="image/*" filled color="#0080aa" @change="idImgUpload()" v-model="id_img.bin"
                              prepend-icon="mdi-image" :disabled="disabled"></v-file-input>
              </v-col>
              <v-col cols="3" class="px-3" style="width: 30%;height: 70px;position: relative;margin-bottom: 10px"
                     v-for="(c, i) in id_img.idimg_list" :key="i">
                <v-img :src="baseUrl.concat(c.path)" style="height: 100%"></v-img>
                <v-btn color="red" fab dark width="20" height="20" style="position: absolute;top: -10px;right: 0"
                       @click="delIdImg(c.brain_idimg_id)">
                  <v-icon size="12">mdi-close</v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12" class="px-5">
                所处地市 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2 d-flex align-center">
                <div style="width: 33%;height: 56px" class="pr-2">
                  <v-select
                          :items="p"
                          filled
                          v-model="rescue.province"
                          item-text="name"
                          item-value="name"
                          placeholder="省"
                  ></v-select>
                </div>
                <div style="width: 35%;height: 56px;" class="pr-2">
                  <v-select
                          :items="c"
                          filled
                          item-text="name"
                          item-value="name"
                          v-model="rescue.location"
                          placeholder="市"
                  ></v-select>
                </div>
                <div style="width: 36%;height: 56px;">
                  <v-select
                          :items="a"
                          filled
                          item-text="ext_name"
                          item-value="ext_name"
                          v-model="rescue.area"
                          placeholder="区/县"
                  ></v-select>
                </div>

              </v-col>
            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>


        <v-window-item :value="3">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-10 px-5">
                监护人姓名 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <input type="text" v-model="info.guardian" placeholder="请在此处填写监护人姓名" :disabled="disabled">
              </v-col>

              <v-col cols="12" class="mt-10 px-5">
                联系电话 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <input type="text" v-model="info.phone" placeholder="请在此处填写电话" :disabled="disabled">
              </v-col>

              <v-col cols="12" class="mt-10 px-5">
                住址 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <input type="text" v-model="info.address" placeholder="请详细填写居住地址" :disabled="disabled">
              </v-col>
            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item :value="4">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-8 px-5">
                是否康复机构在训 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-btn class="px-10 ml-10" @click="setInAgency('yes')" ref="agencyyes">是</v-btn>
                <v-btn class="px-10 ml-10" @click="setInAgency('no')" ref="agencyno"> 否</v-btn>
              </v-col>
              <template v-if="rescue.in_agency === '是'">
                <v-col cols="12" class="mt-5 px-5">
                  康复机构名称
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col cols="12" class="px-5 mt-2">
                  <input type="text" v-model="rescue.agency_name" placeholder="请填写康复机构名称" :disabled="disabled">
                </v-col>
                <v-col cols="12" class="mt-5 px-5">
                  推荐人
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col cols="12" class="px-5 mt-2">
                  <input type="text" v-model="rescue.agency_person" placeholder="请填写康复机构推荐人" :disabled="disabled">
                </v-col>
                <v-col cols="12" class="mt-5 px-5">
                  推荐人联系方式
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col cols="12" class="px-5 mt-2">
                  <input type="text" v-model="rescue.agency_contact" placeholder="请填写康复机构推荐人联系方式" :disabled="disabled">
                </v-col>
              </template>

            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item :value="5">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-8 px-5">
                患者现存主要问题(可多选) <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-btn block @click="setZhuyaozhengzhuang('yundong')" ref="yundong"> 运动障碍</v-btn>
                <v-btn block class="mt-5" @click="setZhuyaozhengzhuang('zhili')" ref="zhili"> 智力障碍</v-btn>
                <v-btn block class="mt-5" @click="setZhuyaozhengzhuang('yuyan')" ref="yuyan"> 语言障碍</v-btn>
              </v-col>
            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item :value="6">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-8 px-5">
                既往病史(可多选) <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-btn block @click="setBingshi('naotan')" ref="naotan"> 脑瘫</v-btn>
                <v-btn block class="mt-5" @click="setBingshi('dianxian')" ref="dianxian"> 癫痫</v-btn>
                <v-btn block class="mt-5" @click="setBingshi('gudu')" ref="gudu"> 孤独症</v-btn>
                <v-btn block class="mt-5" @click="setBingshi('dixia')" ref="dixia"> 智力低下</v-btn>

              </v-col>
            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item :value="7">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-8 px-5">
                是否用药(单选) <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-btn block @click="setIsfuyao('yes')" ref="fuyaoyes">是</v-btn>
                <v-btn block class="mt-5" @click="setIsfuyao('no')" ref="fuyaono">否</v-btn>
              </v-col>
              <template v-if="info.is_fuyao === '是'">
                <v-col cols="12" class="mt-5 px-5">
                  使用药物(选填)
                  <v-divider class="mt-2"></v-divider>
                </v-col>
                <v-col cols="12" class="px-5 mt-2">
                  <input type="text" v-model="info.fuyao" placeholder="请填写药物名称" :disabled="disabled">
                </v-col>
              </template>

            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item :value="8">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-10 px-5">
                上传过往病历材料照片、CT检查结论照片、基因检测报告书
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-file-input v-model="ct.bin" @change="imgUpload" accept="image/*" filled color="#0080aa"
                              prepend-icon="mdi-image" :disabled="disabled"></v-file-input>
              </v-col>
              <v-col cols="4" class="px-3" style="width: 30%;height: 70px;position: relative;margin-bottom: 10px"
                     v-for="(c, i) in ct.ct_list" :key="i">
                <v-img :src="baseUrl.concat(c.path)" style="height: 100%"></v-img>
                <v-btn color="red" fab dark width="20" height="20" style="position: absolute;top: -10px;right: 0"
                       @click="delCtImg(c.id)">
                  <v-icon size="12">mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" class="mt-10 px-5">
                病症发作短视频
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-file-input @change="videoUpload" v-model="video.bin" accept="video/*" filled color="#0080aa"
                              prepend-icon="mdi-video" :disabled="disabled"></v-file-input>
              </v-col>
              <v-col cols="12" class="white">
                <v-chip v-if="video.video_list !== ''" class="ma-2" color="#0080aa" outlined label close
                        @click:close="delVideo()">
                  {{video.video_list | ellipsis}}
                </v-chip>
              </v-col>
            </v-row>
            <div style="margin-top: 120px;position: relative;height:20px">
              <div class="page">
                <span style="color: #0080aa">{{step}}/10</span>
              </div>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item :value="9">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-8 px-5">
                是否需要申请救助 <span class="red--text">*</span>
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <v-btn block @click="setRescue('1')" ref="rescueyes">是</v-btn>
                <v-btn block class="mt-5" @click="setRescue('0')" ref="rescueno">否</v-btn>
              </v-col>
              <v-col cols="12" class="mt-10 text-center">
                <span class="body-2" style="color: #0080aa" @click="callFullscreen()">点击了解救助申请</span>
              </v-col>
            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="step++">下一步</v-btn>
            </v-col>
          </v-row>
        </v-window-item>

        <v-window-item :value="10">
          <div class="item">
            <v-row no-gutters>
              <v-col cols="12" class="text-center mt-3">
                <span style="color: #fff;font-size: x-large">{{step}}</span>
              </v-col>
              <v-col cols="12" class="mt-8 px-5">
                补充说明
                <v-divider class="mt-2"></v-divider>
              </v-col>
              <v-col cols="12" class="px-5 mt-2">
                <textarea name="" id="" cols="30" rows="5" v-model="info.remark" :disabled="disabled"></textarea>
              </v-col>
            </v-row>
            <div class="page">
              <span style="color: #0080aa">{{step}}/10</span>
            </div>
          </div>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn color="#0080aa" dark class="px-9" @click="submit()" :disabled="disabled">提交</v-btn>
            </v-col>
          </v-row>
        </v-window-item>
      </v-window>

    </v-container>

    <v-dialog v-model="rescueFormShow" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-container fluid>
        <v-card tile class="pa-1">
          <v-row no-gutters>
            <v-col cols="12" class="text-center mt-3">
              <span style="color: #fff;font-size: x-large">申请救助信息</span>
            </v-col>

            <v-col cols="12" class="mt-5 px-5">
              上传建档立卡、低困低保等贫困证明材料照片 <span class="red--text">*</span>
              <v-divider class="mt-2"></v-divider>
            </v-col>
            <v-col cols="12" class="px-5 mt-2">
              <v-file-input accept="image/*" filled color="#0080aa" @change="fileImgUpload()" v-model="file.bin"
                            prepend-icon="mdi-image" :disabled="disabled"></v-file-input>
            </v-col>
            <v-col cols="4" class="px-3" style="width: 30%;height: 70px;position: relative;margin-bottom: 10px"
                   v-for="(c, i) in file.file_list" :key="i">
              <v-img :src="baseUrl.concat(c.path)" style="height: 100%"></v-img>
              <v-btn color="red" fab dark width="20" height="20" style="position: absolute;top: -10px;right: 0"
                     @click="delFileImg(c.id)">
                <v-icon size="12">mdi-close</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="12" class="mt-10 px-5">
              上传患者《残疾人证》材料照片
              <v-divider class="mt-2"></v-divider>
            </v-col>
            <v-col cols="12" class="px-5 mt-2">
              <v-file-input accept="image/*" filled color="#0080aa" @change="rescueIdImgUpload()"
                            v-model="rescue_id_img.bin" prepend-icon="mdi-image" :disabled="disabled"></v-file-input>
            </v-col>
            <v-col cols="4" class="px-3" style="width: 30%;height: 70px;position: relative;margin-bottom: 10px"
                   v-for="(c, i) in rescue_id_img.rescue_id_img_list" :key="i">
              <v-img :src="baseUrl.concat(c.path)" style="height: 100%"></v-img>
              <v-btn color="red" fab dark width="20" height="20" style="position: absolute;top: -10px;right: 0"
                     @click="delRescueIdImg(c.id)">
                <v-icon size="12">mdi-close</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="12" class="mt-5 px-5">
              家庭贫困情况详细说明 <span class="red--text">*</span>
              <v-divider class="mt-2"></v-divider>
            </v-col>
            <v-col cols="12" class="px-5 mt-2">
              <textarea name="" cols="30" rows="5" v-model="rescue.des" ref="des"
                        placeholder="例如低保户、在册贫困户、无直接经济收入等" :disabled="disabled"></textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center px-10">
              <v-btn block color="#0080aa" dark @click="rescueFormShow = false">确定</v-btn>
            </v-col>
          </v-row>
        </v-card>

      </v-container>
    </v-dialog>

    <v-dialog v-model="fullScreenDialog" fullscreen transition="dialog-bottom-transition" scrollable>
      <v-container fluid>
        <v-card tile class="pa-3">
          <v-row>
            <v-col cols="12" class="text-center title">
              救助资格申请说明
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p>救助资格申请需满足两个筛选条件。</p>
              <p>适应证筛选条件：</p>
              <p>儿童脑发育不良手术适应证（包括脑瘫、孤独症等）： 1、脑发育不良患者应选择综合治疗方法。如果药物治疗、康复锻炼效果不佳，根据患者病情可选择机器人微创手术治疗。2、最佳治疗年龄范围
                2-14岁。3、患者运动障碍（如肌张力高、扭转痉挛等）为首选；言语障碍、智力障碍及精神症状为次选，其他各种病症也可得到不同程度的改善。4、病因：出生缺氧、难产、黄疸等因素造成的脑发育不良为首选；遗传基因、代谢性疾病所致脑发育不良为次选。5、手术后应配合其他综合治疗方法（如中医、康复锻炼等）。</p>
              <p>癫痫手术适应证：1、药物难治的顽固性癫痫，经抗癫痫药物治疗一年以上仍不能控制癫痫发作。
                2、癫痫发作频繁，每月3次以上；或者明显影响个人生活质量（日常生活、学习和社会交流）。3、最佳手术指征为局灶性癫痫，例如颞叶癫痫。4、注意除外进行性疾病引发的继发性癫痫（如恶性肿瘤、多发性硬化、脑血管炎、脑血管畸形等）。</p>
              <p>免费救助筛选条件：</p>
              <p>1、申请人户籍须为山东籍；</p>
              <p>2、申请人病症须符合项目适应证范围；</p>
              <p>3、选择免费救助的基本原则是：首先保证建档立卡贫困残疾儿童，同等条件下优先考虑低保重度残疾人家庭患者；若贫困程度相似，则优先选择低龄患者。</p>
              <p>4、对于不符合免费救助条件的患者，可结合自身情况，咨询诺莱医学客服。</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-center">
              <v-btn block color="#0080aa" dark @click="callRescueForm()">我已了解救助项目政策</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-container>

    </v-dialog>

    <v-dialog v-model="confirmDialog" persistent max-width="290">
      <v-card class="mx-auto" outlined>
        <div class="d-flex justify-center align-content-center my-3">
          <v-icon x-large color="#0080aa">mdi-check-decagram</v-icon>

        </div>
        <div class="d-flex justify-center align-content-center font-weight-black title">信息提交成功</div>
        <div class="d-flex justify-center align-content-center" style="color:#757575">请等待客服联系</div>
        <div class="d-flex justify-center align-content-center my-5">
          <v-btn rounded color="#0080aa" dark width="150" @click="confirm()">确认</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
            v-model="disabledDialog"
            max-width="290"
    >
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          已经超过10天，当前信息已不可修改
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                  color="#0080aa"
                  text
                  @click="disabledDialog = false"
          >
            知道了
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
  import api from '../api';
  import wx from 'weixin-jsapi';
  import lrz from 'lrz';
  import area from '../plugins/area';

  export default {
    name: "Improve",
    data: function () {
      return {
        baseUrl: api.baseUrl,
        openid: '',
        disabled: false,
        disabledDialog: false,
        info: {},
        idimg_id: [],
        ct_id: [],
        video_id: '',
        rescue_idimg_id: [],
        file_id: [],
        rescue_info: {},
        rescue: {
          des: '',
          in_agency: '',
          agency_name: '',
          agency_person: '',
          agency_contact: '',
          province: '',
          location: '',
          area: ''
        },
        video: {
          bin: null,
          video_list: ''
        },

        ct: {
          bin: null,
          ct_list: [],
        },

        id_img: {
          bin: null,
          idimg_list: [],
        },

        rescue_id_img: {
          bin: null,
          rescue_id_img_list: []
        },

        file: {
          bin: null,
          file_list: [],
        },

        fullScreenDialog: false,
        menu: false,
        modal: false,
        snackbar: false,
        btnDisabled: false,
        confirmDialog: false,
        submitDialog: false,
        rescueFormShow: false,
        sex: [],
        idNoError: false,

        step: 1,
        c: [],
        a: [],
        zz: [],
        bs: []
      }
    },
    computed: {
      p: function () {
        let res = [];
        for (let _p of area) {
          if (_p.pid === '0') {
            res.push(_p)
          }
        }
        return res;
      }
    },
    watch: {
      'rescue.province': {
        handler: function (val) {
          this.c = [];
          for (let i of area) {
            if (i.name === val) {
              for (let j of area) {
                if (j.pid === i.id) {
                  this.c.push(j);
                }
              }
            }
          }
        },
        deep: true,
      },
      'rescue.location': {
        handler: function (val) {
          this.a = [];
          for (let i of area) {
            if (i.name === val) {
              for (let j of area) {
                if (j.pid === i.id) {
                  this.a.push(j);
                }
              }
            }
          }
        },
        deep: true,
      },
      'info.sex': {
        handler: function (val) {
          if (val === '男') {
            this.$refs.male.$el.style.color = '#fff';
            this.$refs.male.$el.style.backgroundColor = '#6080f9';
            this.$refs.female.$el.style.color = '#000';
            this.$refs.female.$el.style.backgroundColor = '#fff';
          } else if (val === '女') {
            this.$refs.female.$el.style.color = '#fff';
            this.$refs.female.$el.style.backgroundColor = '#6080f9';
            this.$refs.male.$el.style.color = '#000';
            this.$refs.male.$el.style.backgroundColor = '#fff';
          }
        },
        deep: true
      },
      step: {
        handler: function (val) {
          switch (val) {
            case 4:
              if (this.rescue.in_agency === '是') {
                setTimeout(() => {
                  this.$refs.agencyyes.$el.style.color = '#fff';
                  this.$refs.agencyyes.$el.style.backgroundColor = '#6080f9';
                  this.$refs.agencyno.$el.style.color = '#000';
                  this.$refs.agencyno.$el.style.backgroundColor = '#fff';
                }, 500)

              } else if (this.rescue.in_agency === '否') {
                setTimeout(() => {
                  this.$refs.agencyno.$el.style.color = '#fff';
                  this.$refs.agencyno.$el.style.backgroundColor = '#6080f9';
                  this.$refs.agencyyes.$el.style.color = '#000';
                  this.$refs.agencyyes.$el.style.backgroundColor = '#fff';
                }, 500)

              }
              break;
            case 5:
              if (this.info.zhuyaozhengzhuang.indexOf('运动障碍') !== -1) {
                this.zz.push('运动障碍');
                setTimeout(() => {
                  this.$refs.yundong.$el.style.color = '#fff';
                  this.$refs.yundong.$el.style.backgroundColor = '#6080f9';
                })
              }
              if (this.info.zhuyaozhengzhuang.indexOf('智力障碍') !== -1) {
                this.zz.push('智力障碍');
                setTimeout(() => {
                  this.$refs.zhili.$el.style.color = '#fff';
                  this.$refs.zhili.$el.style.backgroundColor = '#6080f9';
                })
              }
              if (this.info.zhuyaozhengzhuang.indexOf('语言障碍') !== -1) {
                this.zz.push('语言障碍');
                setTimeout(() => {
                  this.$refs.yuyan.$el.style.color = '#fff';
                  this.$refs.yuyan.$el.style.backgroundColor = '#6080f9';
                })
              }
              break;
            case 6:
              if (this.info.bingshi.indexOf('脑瘫') !== -1) {
                this.bs.push('脑瘫');
                setTimeout(() => {
                  this.$refs.naotan.$el.style.color = '#fff';
                  this.$refs.naotan.$el.style.backgroundColor = '#6080f9';
                })
              }
              if (this.info.bingshi.indexOf('癫痫') !== -1) {
                this.bs.push('癫痫');
                setTimeout(() => {
                  this.$refs.dianxian.$el.style.color = '#fff';
                  this.$refs.dianxian.$el.style.backgroundColor = '#6080f9';
                })
              }
              if (this.info.bingshi.indexOf('孤独症') !== -1) {
                this.bs.push('孤独症');
                setTimeout(() => {
                  this.$refs.gudu.$el.style.color = '#fff';
                  this.$refs.gudu.$el.style.backgroundColor = '#6080f9';
                })
              }
              if (this.info.bingshi.indexOf('智力低下') !== -1) {
                this.bs.push('智力低下');
                setTimeout(() => {
                  this.$refs.dixia.$el.style.color = '#fff';
                  this.$refs.dixia.$el.style.backgroundColor = '#6080f9';
                })
              }
              break;
            case 7:
              if (this.info.is_fuyao === '是') {
                setTimeout(() => {
                  this.$refs.fuyaoyes.$el.style.color = '#fff';
                  this.$refs.fuyaoyes.$el.style.backgroundColor = '#6080f9';
                  this.$refs.fuyaono.$el.style.color = '#000';
                  this.$refs.fuyaono.$el.style.backgroundColor = '#fff';
                }, 500)
              } else {
                setTimeout(() => {
                  this.$refs.fuyaono.$el.style.color = '#fff';
                  this.$refs.fuyaono.$el.style.backgroundColor = '#6080f9';
                  this.$refs.fuyaoyes.$el.style.color = '#000';
                  this.$refs.fuyaoyes.$el.style.backgroundColor = '#fff';
                }, 500)
              }
              break;
            case 9:
              if(this.info.rescue === 1) {
                setTimeout(()=>{
                  this.rescueFormShow = true;
                  this.$refs.rescueyes.$el.style.color = '#fff';
                  this.$refs.rescueyes.$el.style.backgroundColor = '#6080f9';
                  this.$refs.rescueno.$el.style.color = '#000';
                  this.$refs.rescueno.$el.style.backgroundColor = '#fff';
                }, 500)
              } else {
                setTimeout(()=>{
                  this.$refs.rescueno.$el.style.color = '#fff';
                  this.$refs.rescueno.$el.style.backgroundColor = '#6080f9';
                  this.$refs.rescueyes.$el.style.color = '#000';
                  this.$refs.rescueyes.$el.style.backgroundColor = '#fff';
                }, 500)
              }
          }
        },
        deep: true
      }
    },
    methods: {
      setIsfuyao: function (fuyao) {
        if (fuyao === 'yes') {
          this.info.is_fuyao = '是';
          this.$refs.fuyaoyes.$el.style.color = '#fff';
          this.$refs.fuyaoyes.$el.style.backgroundColor = '#6080f9';
          this.$refs.fuyaono.$el.style.color = '#000';
          this.$refs.fuyaono.$el.style.backgroundColor = '#fff';
        } else if (fuyao === 'no') {
          this.info.is_fuyao = '否';
          this.$refs.fuyaono.$el.style.color = '#fff';
          this.$refs.fuyaono.$el.style.backgroundColor = '#6080f9';
          this.$refs.fuyaoyes.$el.style.color = '#000';
          this.$refs.fuyaoyes.$el.style.backgroundColor = '#fff';
        }
      },
      setBingshi: function (bingshi) {
        if (bingshi === 'naotan') {
          const index = this.bs.indexOf('脑瘫')
          if (index === -1) {
            this.bs.push('脑瘫');
            this.$refs.naotan.$el.style.color = '#fff';
            this.$refs.naotan.$el.style.backgroundColor = '#6080f9';
          } else {
            this.bs.splice(index, 1);
            this.$refs.naotan.$el.style.color = '#000';
            this.$refs.naotan.$el.style.backgroundColor = '#fff';
          }
        }
        if (bingshi === 'dianxian') {
          const index = this.bs.indexOf('癫痫')
          if (index === -1) {
            this.bs.push('癫痫');
            this.$refs.dianxian.$el.style.color = '#fff';
            this.$refs.dianxian.$el.style.backgroundColor = '#6080f9';
          } else {
            this.bs.splice(index, 1);
            this.$refs.dianxian.$el.style.color = '#000';
            this.$refs.dianxian.$el.style.backgroundColor = '#fff';
          }
        }
        if (bingshi === 'gudu') {
          const index = this.bs.indexOf('孤独症')
          if (index === -1) {
            this.bs.push('孤独症');
            this.$refs.gudu.$el.style.color = '#fff';
            this.$refs.gudu.$el.style.backgroundColor = '#6080f9';
          } else {
            this.bs.splice(index, 1);
            this.$refs.gudu.$el.style.color = '#000';
            this.$refs.gudu.$el.style.backgroundColor = '#fff';
          }
        }
        if (bingshi === 'dixia') {
          const index = this.bs.indexOf('智力低下')
          if (index === -1) {
            this.bs.push('智力低下');
            this.$refs.dixia.$el.style.color = '#fff';
            this.$refs.dixia.$el.style.backgroundColor = '#6080f9';
          } else {
            this.bs.splice(index, 1);
            this.$refs.dixia.$el.style.color = '#000';
            this.$refs.dixia.$el.style.backgroundColor = '#fff';
          }
        }
        this.info.bingshi = this.bs.toString();
      },
      setZhuyaozhengzhuang: function (zhengzhuang) {
        if (zhengzhuang === 'yundong') {
          const index = this.zz.indexOf('运动障碍')
          if (index === -1) {
            this.zz.push('运动障碍');
            this.$refs.yundong.$el.style.color = '#fff';
            this.$refs.yundong.$el.style.backgroundColor = '#6080f9';
          } else {
            this.zz.splice(index, 1);
            this.$refs.yundong.$el.style.color = '#000';
            this.$refs.yundong.$el.style.backgroundColor = '#fff';
          }
        }
        if (zhengzhuang === 'zhili') {
          const index = this.zz.indexOf('智力障碍')
          if (index === -1) {
            this.zz.push('智力障碍');
            this.$refs.zhili.$el.style.color = '#fff';
            this.$refs.zhili.$el.style.backgroundColor = '#6080f9';
          } else {
            this.zz.splice(index, 1);
            this.$refs.zhili.$el.style.color = '#000';
            this.$refs.zhili.$el.style.backgroundColor = '#fff';
          }
        }
        if (zhengzhuang === 'yuyan') {
          const index = this.zz.indexOf('语言障碍')
          if (index === -1) {
            this.zz.push('语言障碍');
            this.$refs.yuyan.$el.style.color = '#fff';
            this.$refs.yuyan.$el.style.backgroundColor = '#6080f9';
          } else {
            this.zz.splice(index, 1);
            this.$refs.yuyan.$el.style.color = '#000';
            this.$refs.yuyan.$el.style.backgroundColor = '#fff';
          }
        }
        this.info.zhuyaozhengzhuang = this.zz.toString();
        console.log(this.info.zhuyaozhengzhuang);
      },
      setInAgency: function (status) {
        if (status === 'yes') {
          this.rescue.in_agency = '是';
          this.$refs.agencyyes.$el.style.color = '#fff';
          this.$refs.agencyyes.$el.style.backgroundColor = '#6080f9';
          this.$refs.agencyno.$el.style.color = '#000';
          this.$refs.agencyno.$el.style.backgroundColor = '#fff'
        } else if (status === 'no') {
          this.rescue.in_agency = '否';
          this.$refs.agencyyes.$el.style.color = '#000';
          this.$refs.agencyyes.$el.style.backgroundColor = '#fff';
          this.$refs.agencyno.$el.style.color = '#fff';
          this.$refs.agencyno.$el.style.backgroundColor = '#6080f9'
        }
        console.log(this.rescue)
      },
      setSex: function (sex) {
        if (sex === 'male') {
          this.info.sex = '男';
          this.$refs.male.$el.style.color = '#fff';
          this.$refs.male.$el.style.backgroundColor = '#6080f9';
          this.$refs.female.$el.style.color = '#000';
          this.$refs.female.$el.style.backgroundColor = '#fff';
        } else if (sex === 'female') {
          this.info.sex = '女';
          this.$refs.female.$el.style.color = '#fff';
          this.$refs.female.$el.style.backgroundColor = '#6080f9';
          this.$refs.male.$el.style.color = '#000';
          this.$refs.male.$el.style.backgroundColor = '#fff';
        }
      },
      setRescue: function (s) {
        this.info.rescue = s

        if (s === '1') {
          this.rescueFormShow = true;
          this.$refs.rescueyes.$el.style.color = '#fff';
          this.$refs.rescueyes.$el.style.backgroundColor = '#6080f9';
          this.$refs.rescueno.$el.style.color = '#000';
          this.$refs.rescueno.$el.style.backgroundColor = '#fff';
        } else if (s === '0') {
          this.$refs.rescueno.$el.style.color = '#fff';
          this.$refs.rescueno.$el.style.backgroundColor = '#6080f9';
          this.$refs.rescueyes.$el.style.color = '#000';
          this.$refs.rescueyes.$el.style.backgroundColor = '#fff';
        }
      },
      callFullscreen: function () {
        this.fullScreenDialog = true;
      },
      callRescueForm: function () {
        this.fullScreenDialog = false;
      },

      submit: function () {
        if (this.info.name === '') {
          this.step = 1;
          this.$store.dispatch('snkbar', {show: true, txt: '姓名是必填项'});
          this.$http.post(api.errLog, {item: 'name', content: this.info.name})
          return;
        }
        if (this.info.sex === '') {
          this.step = 1;
          this.$store.dispatch('snkbar', {show: true, txt: '性别是必填项'});
          this.$http.post(api.errLog, {item: 'sex', content: this.info.sex})
          return;
        }
        if (this.info.birthday === '') {
          this.step = 1;
          this.$store.dispatch('snkbar', {show: true, txt: '出生年月是必填项'});
          this.$http.post(api.errLog, {item: 'birthday', content: this.info.birthday})
          return;
        }
        if (this.info.id_no === '') {
          this.step = 2;
          this.$store.dispatch('snkbar', {show: true, txt: '身份证号是必填项'});
          this.$http.post(api.errLog, {item: 'id_no', content: this.info.id_no})
          return;
        }
        if (!this.rescue.province || !this.rescue.location || !this.rescue.area ) {
          this.step = 2;
          this.$store.dispatch('snkbar', {show: true, txt: '所处地市是必选项'});
          this.$http.post(api.errLog, {item: 'id_no', content: this.info.id_no})
          return;
        }
        if (this.checkIdNo()) {
          this.step = 2;
          this.$store.dispatch('snkbar', {show: true, txt: '身份证号格式错误'});
          this.$http.post(api.errLog, {item: 'id_no', content: this.info.id_no})
          return;
        }
        if (this.info.guardian === '') {
          this.step = 3;
          this.$store.dispatch('snkbar', {show: true, txt: '监护人姓名是必填项'});
          this.$http.post(api.errLog, {item: 'guardian', content: this.info.guardian})
          return;
        }
        if (this.info.phone === '') {
          this.step = 3;
          this.$store.dispatch('snkbar', {show: true, txt: '联系电话是必填项'});
          this.$http.post(api.errLog, {item: 'phone', content: this.info.phone})
          return;
        }
        if (this.info.address === '') {
          this.step = 3;
          this.$store.dispatch('snkbar', {show: true, txt: '居住地址是必填项'});
          this.$http.post(api.errLog, {item: 'address', content: this.info.address})
          return;
        }
        if (this.rescue.in_agency === '') {
          this.step = 4;
          this.$store.dispatch('snkbar', {show: true, txt: '是否康复机构在训必选项'});
          return;
        }
        if (this.info.zhuyaozhengzhuang === '') {
          this.step = 5;
          this.$store.dispatch('snkbar', {show: true, txt: '患者现存主要问题是必选项'});
          return;
        }
        if (this.info.bingshi === '') {
          this.step = 6;
          this.$store.dispatch('snkbar', {show: true, txt: '既往病史是必选项'});
          return;
        }
        if (this.info.is_fuyao === '') {
          this.step = 7;
          this.$store.dispatch('snkbar', {show: true, txt: '是否用药是必选项'});
          return;
        }
        if (this.info.rescue === '') {
          this.step = 9;
          this.$store.dispatch('snkbar', {show: true, txt: '是否申请救助是必选项'});
          return;
        }
        if (this.idimg_id.length === 0) {
          this.step = 2;
          this.$store.dispatch('snkbar', {show: true, txt: '身份证正反面或户口本单页必须上传'});
          this.$http.post(api.errLog, {item: 'address', content: this.info.idimg_id})
          return;
        }
        if (this.info.rescue === '1' && this.file_id.length === 0) {
          this.step = 9;
          this.rescueFormShow = true;
          this.$store.dispatch('snkbar', {show: true, txt: '低困低保材料必须上传'});
          this.$http.post(api.errLog, {item: 'address', content: this.info.rescue_info.file_id})
          return;
        }
        if (this.info.rescue === '1' && this.rescue.des === '') {
          this.step = 9;
          this.rescueFormShow = true;
          this.$store.dispatch('snkbar', {show: true, txt: '贫困情况说明是必填项'});
          this.$http.post(api.errLog, {item: 'address', content: this.info.rescue_info.des})
          return;
        }
        this.$http.post(api.improve, {openid: this.openid, brain: this.info, ct: this.ct_id, idimg: this.idimg_id, video: this.video_id, rescue_idimg: this.rescue_idimg_id, file: this.file_id, rescue: this.rescue}).then(response => {
          if (response.data.success) {
            this.confirmDialog = true;
          } else {
            console.log(response);
            this.$store.dispatch('snkbar', {show: true, txt: response.data.err})
          }
        })

      },
      confirm: function () {
        this.confirmDialog = false;
        wx.closeWindow();
      },

      imgUpload: function () {
        if (this.ct.bin) {
          const that = this;
          lrz(this.ct.bin, {fieldName: 'ct'}).then(function (res) {
            that.$http.post(api.imgUpload, res.formData).then(response => {
              if (response.data.success) {
                that.ct_id.push(response.data.id);
                that.ct.ct_list.push({id: response.data.id, path: response.data.path});
                that.ct.bin = null;
              } else {
                console.log(response);
              }
            })
          })

        }
      },
      idImgUpload: function () {
        if (this.id_img.bin) {
          const that = this;
          lrz(this.id_img.bin, {fieldName: 'id_img'}).then(function (res) {
            that.$http.post(api.idImgUpload, res.formData).then(response => {
              if (response.data.success) {
                that.idimg_id.push(response.data.brain_idimg_id);
                that.id_img.idimg_list.push({brain_idimg_id: response.data.brain_idimg_id, path: response.data.path});
                that.id_img.bin = null;
              } else {
                console.log(response);
              }
            })
          });

        }
      },
      rescueIdImgUpload: function () { // 残疾证上传
        if (this.rescue_id_img.bin) {
          const that = this;
          lrz(this.rescue_id_img.bin, {fieldName: 'rescue_id_img'}).then(function (res) {
            that.$http.post(api.rescueIdImgUpload, res.formData).then(response => {
              if (response.data.success) {
                that.rescue_idimg_id.push(response.data.id);
                that.rescue_id_img.rescue_id_img_list.push({id: response.data.id, path: response.data.path});
                that.rescue_id_img.bin = null;
              } else {
                console.log(response);
              }
            })
          });

        }
      },
      fileImgUpload: function () {
        if (this.file.bin) {
          const that = this;
          lrz(this.file.bin, {fieldName: 'file_img'}).then(function (res) {
            that.$http.post(api.fileImgUpload, res.formData).then(response => {
              if (response.data.success) {
                that.file_id.push(response.data.id);
                that.file.file_list.push({id: response.data.id, path: response.data.path});
                that.file.bin = null;
              } else {
                console.log(response);
              }
            })
          });

        }
      },
      videoUpload: function () {
        if (this.video.bin) {
          let formData = new FormData();
          formData.append('video', this.video.bin);
          this.$http.post(api.videoUpload, formData).then(response => {
            if (response.data.success) {
              this.video_id = response.data.res;
              this.video.video_list = this.video.bin.name;
              this.video.bin = null;
            } else {
              console.log(response);
            }
          })
        }
      },
      delCtImg: function (id) {
        this.ct.ct_list.splice(this.ct.ct_list.findIndex(item => item.id === id), 1);
        this.ct_id.splice(this.ct_id.findIndex(item => item === id), 1);
      },
      delIdImg: function (id) {
        this.id_img.idimg_list.splice(this.id_img.idimg_list.findIndex(item => item.brain_idimg_id === id), 1);
        this.idimg_id.splice(this.idimg_id.findIndex(item => item === id), 1);
      },
      delFileImg: function (id) {
        this.file.file_list.splice(this.file.file_list.findIndex(item => item.id === id), 1);
        this.file_id.splice(this.file_id.findIndex(item => item === id), 1);
      },
      delVideo: function () {
        this.video.video_list = '';
        this.video_id = '';
      },
      delRescueIdImg: function(id){
        this.rescue_id_img.rescue_id_img_list.splice(this.rescue_id_img.rescue_id_img_list.findIndex(item => item.id === id), 1);
        this.rescue_idimg_id.splice(this.rescue_idimg_id.findIndex(item => item === id), 1);
      },
      checkIdNo: function () {
        var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
        //号码规则校验
        if (!format.test(this.info.id_no)) {
          return true;
        }
        //区位码校验
        //出生年月日校验   前正则限制起始年份为1900;
        const year = this.info.id_no.substr(6, 4),//身份证年
          month = this.info.id_no.substr(10, 2),//身份证月
          date = this.info.id_no.substr(12, 2),//身份证日
          time = Date.parse(month + '-' + date + '-' + year),//身份证日期时间戳date
          now_time = Date.parse(new Date()),//当前时间戳
          dates = (new Date(year, month, 0)).getDate();//身份证当月天数
        if (time > now_time || date > dates) {
          return true;
        }
        //校验码判断
        const c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);   //系数
        const b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');  //校验码对照表
        const id_array = this.info.id_no.split("");
        console.log(id_array);
        let sum = 0;
        for (let k = 0; k < 17; k++) {
          sum += parseInt(id_array[k]) * parseInt(c[k]);
        }
        if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
          return true;
        }
        return false;
      }
    },
    mounted() {
      document.title = "患者信息登记表";

      this.openid = this.$route.query.openid;

      this.$http.get(api.getInfo, {params: {openid: this.openid}}).then(response => {
        if (response.data.success) {
          this.info = response.data.brain;
          this.disabled = response.data.disabled;

          if(this.disabled) {
            this.disabledDialog = true;
          }
          this.id_img.idimg_list = response.data.idimg;
          if (response.data.idimg.length !== 0) {
            for (let item of response.data.idimg) {
              this.idimg_id.push(item.brain_idimg_id)
            }
          }
          this.ct.ct_list = response.data.imgs;
          if (response.data.imgs.length !== 0) {
            for (let item of response.data.imgs) {
              this.ct_id.push(item.id)
            }
          }
          this.video_id = response.data.video.id;
          this.video.video_list = response.data.video.path

          // this.rescue = response.data.rescue;
          if(response.data.rescue.length !== 0){
            this.rescue = response.data.rescue;
          }

          this.file.file_list = response.data.rescue_file;
          if(response.data.rescue_file.length !== 0){
            for(let item of response.data.rescue_file){
              this.file_id.push(item.id)
            }
          }

          this.rescue_id_img.rescue_id_img_list = response.data.rescue_idimg;
          if(response.data.rescue_idimg.length !== 0) {
            for(let item of response.data.rescue_idimg) {
              this.rescue_idimg_id.push(item.id)
            }
          }
        } else {
          console.log(response);
        }
      })

      const url = window.location.href;
      this.$http.post(api.getConfig, {url: url}).then(response => {
        if (response.data.success) {
          wx.config({
            debug: false,
            appId: response.data.res.appid,
            timestamp: response.data.res.timestamp,
            nonceStr: response.data.res.noncestr,
            signature: response.data.res.signature,
            jsApiList: ['closeWindow']
          });
          wx.ready(function () {
            wx.checkJsApi({
              jsApiList: ['closeWindow'],
              success: function (res) {
                console.log("success");
                console.log(res)
              },
              fail: function (res) {
                console.log("fail");
                console.log(res)
              }
            });
          })
        } else {
          console.log(response);
        }
      })
    }
  }
</script>

<style scoped>
  .corner {
    position: absolute;
    /*background-color: #0080aa;*/
    width: 120px;
    height: 80px;
    border-radius: 35px;
    top: -26px;
    left: -75px;
    color: black;
    font-weight: bold;
    font-size: 20px;
  }

  input {
    box-sizing: border-box;
    /*font-size:1em;*/
    height: 3.2em;
    border-radius: 4px;
    /*border: 1px solid #e5e5e5 !important;*/
    background-color: #F5F5F5;
    color: #6a6f77;
    -web-kit-appearance: none;
    -moz-appearance: none;
    display: block;
    outline: 0;
    padding: 0 1em;
    text-decoration: none;
    width: 100%;
  }

  input[type="text"]:focus {
    border: 1px solid #0080aa;
  }

  textarea {
    box-sizing: border-box;
    border-radius: 4px;
    /*border: 1px solid #e5e5e5;*/
    background-color: #F5F5F5;
    color: #6a6f77;
    -web-kit-appearance: none;
    -moz-appearance: none;
    display: block;
    outline: 0;
    padding: 5px 5px;
    text-decoration: none;
    width: 100%;
  }

  textarea:focus {
    border: 1px solid #0080aa;
  }

  input::-webkit-input-placeholder {
    color: #ccc;
  }

  textarea::-webkit-input-placeholder {
    color: #ccc;
  }

  .item {
    background: url("~@/assets/card-bg.png") no-repeat;
    background-size: 100% 100%;
    min-height: 540px;
    width: 100%;
    position: relative;
    overflow-y: auto;
  }

  .page {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .v-input__slot {
    padding: 0 !important;
    height: 30px !important;
  }
</style>

